<template>
  <page>
    <div slot="head" class="page-head-default">
      {{ i18n.continue_with_whatsapp }}
    </div>
    <div class="login-wa-complete-warp">
      <div class="top-tips">{{ i18n.approved_redirecting }}</div>
    </div>
  </page>
</template>

<script>
import { WA_LOGIN_COMPLETE } from "../../apis/user"
import UserAuth from "../../mixins/user_auth"

// WhatsApp魔法链接完成页:用户在聊天里点开带t的链接,换JWT登录并带上qrcode继续租借
export default {
  mixins: [UserAuth],
  computed: {
    i18n() {
      return this.$t("login")
    }
  },
  methods: {
    goNext(qrcode, redirect) {
      // 登录前被拦截的页面(如未支付订单/支付页),登录后优先跳回
      if (redirect && !redirect.startsWith("/login")) {
        this.$router.push(redirect)
        return
      }
      // 带机柜qrcode的扫码租借场景:回首页走标准扫码流程(onScan拉机柜信息→扫码成功弹窗→继续租借付款)
      // 注意:在WhatsApp内置浏览器打开,本地没有任何扫码上下文,不能直接跳selectPakage(缺cabinet数据)
      if (qrcode) {
        this.$router.push("/?qrcode=" + qrcode)
      } else {
        this.$router.push("/")
      }
    },
    // 链接失效(过期/已被消费):已登录回首页,未登录回登录页并提示
    onInvalidLink(msg) {
      this.$loading(false)
      this.$toast(msg)
      if (this.$store.state.token) {
        this.$router.replace("/")
      } else {
        this.$router.replace("/login")
      }
    }
  },
  created() {
    const t = this.$route.query.t
    if (!t) {
      this.onInvalidLink(this.i18n.session_expired)
      return
    }
    this.$loading(true)
    this.$get(
      WA_LOGIN_COMPLETE,
      { t },
      (res) => {
        this.$loading(false)
        if (res.token) {
          // loginByToken同步写入token后立即生效,直接跳转;
          // 不能用user watcher跳转:第二次打开时user已从localStorage恢复,val&&!oldVal不触发会卡在本页
          this.loginByToken(res.token)
          this.goNext(res.qrcode, res.redirect)
        } else {
          this.onInvalidLink(this.i18n.msg_fail_login)
        }
      },
      (err) => {
        console.log(err)
        this.onInvalidLink(err)
      }
    )
  }
}
</script>

<style lang="less">
.login-wa-complete-warp {
  color: #161616;
  font-size: 28px;
  background-color: #fff;
  padding: 0 55px;
  position: fixed;
  top: 80px;
  bottom: 0;
  left: 0;
  right: 0;
  .top-tips {
    padding: 120px 0;
    text-align: center;
    line-height: 40px;
  }
}
</style>
